module.exports = __webpack_public_path__ + "aedff5cc6990ea3c6c15f30919df34d2.png";